import React from 'react';
import { Grid2, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import { brandTokens } from '../single-page/theme';

const STEPS = [
  {
    n: '1',
    title: 'Digite a placa',
    description: 'Insira a placa do veículo que deseja consultar em nossa base de dados.',
    Icon: SearchOutlinedIcon,
  },
  {
    n: '2',
    title: 'Escolha o plano',
    description: 'Selecione o nível de detalhamento que você precisa para sua análise.',
    Icon: ListAltOutlinedIcon,
  },
  {
    n: '3',
    title: 'Receba o laudo',
    description: 'Pronto! O laudo detalhado aparece na sua tela e também no seu e-mail.',
    Icon: VerifiedUserOutlinedIcon,
  },
];

const RootGrid = styled(Grid2)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  margin: 0,
  padding: 0,
  backgroundColor: brandTokens.surface,
  overflow: 'hidden',
}));

const ContentBlock = styled('div')(({ theme }) => ({
  color: '#FFF',
  width: '100%',
  maxWidth: 1280,
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(10, 3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(6, 2),
  },
}));

const TitleMain = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontFamily: 'GT Haptik, Raleway, sans-serif',
  fontWeight: 700,
  fontSize: '36px',
  lineHeight: 1.2,
  marginBottom: theme.spacing(1.5),
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
  },
}));

const GradientWord = styled('span')({
  background: brandTokens.signatureGradient,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
});

const SubTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontFamily: 'Roboto, sans-serif',
  fontSize: '16px',
  lineHeight: 1.6,
  maxWidth: 560,
  color: brandTokens.onSurfaceVariant,
  marginBottom: theme.spacing(8),
}));

const StepCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  position: 'relative',
  zIndex: 1,
  height: '100%',
}));

const OutlineNumber = styled(Typography)({
  fontFamily: 'GT Haptik, Raleway, sans-serif',
  fontWeight: 700,
  fontSize: 96,
  lineHeight: 1,
  WebkitTextStroke: '1px rgba(107, 211, 253, 0.35)',
  color: 'transparent',
  userSelect: 'none',
  marginBottom: -24,
  opacity: 0.7,
});

const IconBox = styled(Box)({
  width: 80,
  height: 80,
  borderRadius: 16,
  backgroundColor: brandTokens.surfaceContainer,
  border: '1px solid rgba(255,255,255,0.06)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 20,
  transition: 'border-color 0.2s ease',
  '& svg': {
    fontSize: 36,
    color: brandTokens.cyan,
  },
  '&:hover': {
    borderColor: brandTokens.cyan,
  },
});

const HowItWorks = () => {
  return (
    <RootGrid container>
      <ContentBlock>
        <TitleMain variant="h2">
          A rapidez que seu <GradientWord>negócio exige</GradientWord>
        </TitleMain>
        <SubTitle>
          Em apenas três passos simples, você tem acesso ao histórico completo de
          qualquer veículo em território nacional.
        </SubTitle>
        <Grid2 container spacing={4} justifyContent="center">
          {STEPS.map(({ n, title, description, Icon }) => (
            <Grid2 size={{ xs: 12, md: 4 }} key={n}>
              <StepCard>
                <OutlineNumber aria-hidden>{n}</OutlineNumber>
                <IconBox>
                  <Icon />
                </IconBox>
                <Typography
                  sx={{
                    fontFamily: 'GT Haptik, Roboto, sans-serif',
                    fontWeight: 600,
                    fontSize: 20,
                    mb: 1,
                    color: brandTokens.onSurface,
                  }}
                >
                  {title}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: 15,
                    lineHeight: 1.6,
                    color: brandTokens.onSurfaceVariant,
                    maxWidth: 280,
                  }}
                >
                  {description}
                </Typography>
              </StepCard>
            </Grid2>
          ))}
        </Grid2>
      </ContentBlock>
    </RootGrid>
  );
};

export default HowItWorks;
